import * as Yup from 'yup';

// Definindo o esquema de validação com Yup
export const DrawerUploadImageSchema = Yup.object().shape({
    ordering: Yup.string().required('Ordenação é obrigatória'),
    image: Yup.array()
        .min(1, 'Pelo menos uma imagem é obrigatória') // Validação para garantir que pelo menos uma imagem seja enviada
        .required('A imagem é obrigatória'),
});